import { Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import type { ReactElement, ReactNode } from "react";

const StatusText = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: theme.typography.fontWeightSemiBold,
}));

const StyledStack = styled(Stack)(({ theme }) => ({
  ".MuiSvgIcon-root": {
    color: theme.palette.primary.main,
    fontSize: 16,
  },
}));

export interface IconTextProps {
  icon: ReactElement;
  children: ReactNode;
}

export function IconText({ icon, children }: IconTextProps) {
  return (
    <StyledStack direction="row" alignItems="center" gap={0.5}>
      {icon}
      <StatusText variant="body2">{children}</StatusText>
    </StyledStack>
  );
}
